import { render, staticRenderFns } from "./day-of-week.vue?vue&type=template&id=23f26f30&scoped=true&"
import script from "./day-of-week.vue?vue&type=script&lang=ts&"
export * from "./day-of-week.vue?vue&type=script&lang=ts&"
import style0 from "./day-of-week.vue?vue&type=style&index=0&id=23f26f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f26f30",
  null
  
)

export default component.exports